module.exports = __webpack_public_path__ + "static/media/rallyIcon.0540ac2b.svg";